export enum GroupByType {
  USER = "USER",
  TEAM = "TEAM",
  GROUP = "GROUP",
}
